import { useState } from "react";

const dimensions = [
  { label: "人口热力", score: 88, color: "from-red-400 to-orange-400" },
  { label: "客群匹配", score: 91, color: "from-violet-400 to-purple-400" },
  { label: "业态契合", score: 84, color: "from-blue-400 to-cyan-400" },
  { label: "商业活力", score: 93, color: "from-amber-400 to-yellow-400" },
  { label: "交通指数", score: 87, color: "from-teal-400 to-emerald-400" },
  { label: "竞品压力", score: 72, color: "from-rose-400 to-pink-400" },
];

const compareLocations = [
  { name: "选址A · 朝阳大悦城旁", total: 89, scores: [88, 91, 84, 93, 87, 72], rec: "强烈推荐" },
  { name: "选址B · 望京苏宁广场", total: 76, scores: [72, 80, 71, 85, 68, 88], rec: "建议" },
  { name: "选址C · 国贸商圈附近", total: 82, scores: [95, 85, 76, 91, 92, 55], rec: "推荐" },
];

export default function BACharts() {
  const [activeLocation, setActiveLocation] = useState(0);

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-semibold text-emerald-600 tracking-widest uppercase mb-2 block">Location Scoring</span>
            <h2 className="text-3xl font-bold text-slate-800">选址评分对比看板</h2>
            <p className="text-slate-500 text-sm mt-1">六维度智能评分，帮助您做出科学选址决策</p>
          </div>
          <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
            {compareLocations.map((loc, i) => (
              <button
                key={i}
                onClick={() => setActiveLocation(i)}
                className={`px-3 py-2 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeLocation === i ? "bg-white text-emerald-700 shadow-sm font-semibold" : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {loc.name.split("·")[0].trim()}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {/* Radar-style bars */}
          <div className="col-span-2 bg-slate-50 rounded-2xl p-6 border border-slate-100">
            <div className="flex items-center justify-between mb-5">
              <div>
                <h4 className="text-slate-800 font-semibold text-sm">{compareLocations[activeLocation].name}</h4>
                <p className="text-slate-400 text-xs mt-0.5">六维度综合评分分析</p>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs font-bold px-3 py-1 rounded-full ${compareLocations[activeLocation].total >= 88 ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                  {compareLocations[activeLocation].rec}
                </span>
                <span className="text-2xl font-bold text-emerald-600">{compareLocations[activeLocation].total}</span>
                <span className="text-slate-400 text-sm">/ 100</span>
              </div>
            </div>
            <div className="space-y-4">
              {dimensions.map((d, i) => (
                <div key={d.label} className="flex items-center gap-4">
                  <span className="text-slate-600 text-sm font-medium w-20 flex-shrink-0">{d.label}</span>
                  <div className="flex-1 bg-slate-200 rounded-full h-5 overflow-hidden">
                    <div
                      className={`h-5 rounded-full bg-gradient-to-r ${d.color} flex items-center justify-end pr-2 transition-all`}
                      style={{ width: `${compareLocations[activeLocation].scores[i]}%` }}
                    >
                      <span className="text-white text-xs font-bold">{compareLocations[activeLocation].scores[i]}</span>
                    </div>
                  </div>
                  <div className="w-14 text-right">
                    <span className={`text-xs font-semibold ${compareLocations[activeLocation].scores[i] >= 85 ? "text-emerald-600" : compareLocations[activeLocation].scores[i] >= 70 ? "text-amber-600" : "text-rose-500"}`}>
                      {compareLocations[activeLocation].scores[i] >= 85 ? "优秀" : compareLocations[activeLocation].scores[i] >= 70 ? "良好" : "一般"}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Location comparison mini bar */}
            <div className="mt-6 pt-5 border-t border-slate-200">
              <div className="text-xs text-slate-500 font-medium mb-3">三选址总分对比</div>
              <div className="flex items-end gap-3 h-16">
                {compareLocations.map((loc, i) => (
                  <div
                    key={i}
                    className={`flex-1 rounded-t cursor-pointer transition-all ${i === activeLocation ? "opacity-100" : "opacity-50"}`}
                    style={{ height: `${loc.total}%`, background: i === 0 ? "linear-gradient(180deg,#10b981,#059669)" : i === 1 ? "linear-gradient(180deg,#fbbf24,#d97706)" : "linear-gradient(180deg,#34d399,#10b981)" }}
                    onClick={() => setActiveLocation(i)}
                  ></div>
                ))}
              </div>
              <div className="flex gap-3 mt-1">
                {compareLocations.map((loc, i) => (
                  <div key={i} className="flex-1 text-center">
                    <div className="text-xs text-slate-500">{loc.name.split("·")[0].trim()}</div>
                    <div className="text-xs font-bold text-slate-700">{loc.total}分</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right panel */}
          <div className="flex flex-col gap-4">
            <div className="bg-gradient-to-br from-[#0a1f2e] to-[#0d3b2a] rounded-2xl p-5 text-white">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-map-pin-line text-emerald-300"></i>
                <span className="text-white/80 text-xs font-medium">最优选址推荐</span>
              </div>
              <div className="text-lg font-bold text-white mb-0.5">朝阳大悦城旁</div>
              <div className="text-white/50 text-xs mb-3">综合评分 89 · 强烈推荐</div>
              <div className="space-y-2">
                {["日均预估客流 2.3万人", "500m内竞品仅4家", "地铁口步行180m", "目标客群匹配度91%"].map((item) => (
                  <div key={item} className="flex items-center gap-2 text-xs text-white/70">
                    <i className="ri-check-line text-emerald-300 flex-shrink-0"></i>
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-slate-50 border border-slate-100 rounded-2xl p-5 flex-1">
              <h4 className="text-slate-700 font-semibold text-sm mb-4">周边业态构成</h4>
              <div className="space-y-2.5">
                {[
                  { type: "餐饮美食", pct: 34, color: "bg-orange-400" },
                  { type: "时尚零售", pct: 26, color: "bg-blue-400" },
                  { type: "娱乐休闲", pct: 19, color: "bg-violet-400" },
                  { type: "生活服务", pct: 13, color: "bg-teal-400" },
                  { type: "其他", pct: 8, color: "bg-slate-300" },
                ].map((item) => (
                  <div key={item.type} className="flex items-center gap-2">
                    <span className="text-slate-600 text-xs w-16 flex-shrink-0">{item.type}</span>
                    <div className="flex-1 bg-slate-200 rounded-full h-2">
                      <div className={`${item.color} rounded-full h-2 transition-all`} style={{ width: `${item.pct}%` }}></div>
                    </div>
                    <span className="text-slate-500 text-xs w-7 text-right">{item.pct}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
